export default __webpack_public_path__ + "static/spark-new-zealand-0eb4c3090f44ac1dd1d834f8fe88be6a.svg";